import newrelic from "@/lib/monitoring/newrelic";
import { v4 as uuid } from "uuid";

const SEARCH_QUERY_ID_KEY = "search_query_id";

export function createSearchQueryId(): string {
  const searchQueryId = uuid();
  try {
    sessionStorage.setItem(SEARCH_QUERY_ID_KEY, searchQueryId);
  } catch (error) {
    newrelic.noticeError(error as Error, {
      message: "Failed to store search query ID in sessionStorage",
    });
  }
  return searchQueryId;
}

export function getSearchQueryId(): string {
  try {
    const searchQueryId = sessionStorage.getItem(SEARCH_QUERY_ID_KEY);
    if (searchQueryId) {
      return searchQueryId;
    }
  } catch (error) {
    newrelic.noticeError(error as Error, {
      message: "Failed to get search query ID from sessionStorage",
    });
  }

  return createSearchQueryId();
}
